if (!window.__stickyHeaderInitialized) {
  window.__stickyHeaderInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    initStickyHeader();
  });

  function initStickyHeader() {
    const header = document.querySelector(".js-header");
    if (!header) return;

    let isActive = false;

    function onScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > 50 && !isActive) {
        activateHeader(header);
        isActive = true;
      }

      if (currentScroll <= 0 && isActive) {
        deactivateHeader(header);
        isActive = false;
      }
    }

    window.addEventListener("scroll", onScroll);
  }

  function activateHeader(header) {
    header.classList.add("is-sticky");
    document.body.classList.add("with-sticky-header");
  }

  function deactivateHeader(header) {
    header.classList.remove("is-sticky");
    document.body.classList.remove("with-sticky-header");
  }
}